import { AbstractControl, ValidationErrors } from '@angular/forms';

const regexCharacters = /^[a-zA-Z0-9ęóąśłżźćńĘÓĄŚŁŻŹĆŃ .-]*$/;
const maxLength = 50;

const StreetValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = (formControl && (formControl.value as string)) || '';

  if (!value) {
    return {};
  }

  const street = !regexCharacters.test(value);

  if (street) {
    return { street: true };
  }

  if (maxLength < value.length) {
    return { maxLength };
  }

  return {};
};

export default StreetValidator;
